// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3tj_i","filesListContainer":"PosDisputesFiles_filesListContainer__1wjTi","filesButton":"PosDisputesFiles_filesButton__3hd3J"};